module.exports = __webpack_public_path__ + "img/recuperacion_reparacion.34dbf079.png";